// extracted by mini-css-extract-plugin
export default {"privacy":"privacy_privacy-policy_privacy","title":"privacy_privacy-policy_title","description":"privacy_privacy-policy_description"};